(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("accountRedeemCode", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/redeemCode/accountRedeemCodeView.html",
            controller: ["orderItemInventoryResource", "learningPlanService", "$state", AccountRedeemCodeCtrl],
            controllerAs: "vm"
        };
        function AccountRedeemCodeCtrl(orderItemInventoryResource, learningPlanService, $state) {
            var vm = this;
            vm.buttonClicked = false;
            vm.success = false;
            vm.code = $state.params.code;
            vm.redeem = function () {
                if (vm.busy)
                    return;
                if (vm.form.$valid) {
                    vm.busy = true;
                    vm.success = false;
                    vm.error = "";
                    orderItemInventoryResource.redeem({ code: vm.code }, function () {
                        learningPlanService.data = {}; //remove cached learning plan
                        vm.busy = false;
                        vm.success = true;
                        vm.code = "";
                        //2022-11-30 I think we made all accounts "Learners"
                        //if (!authService.authentication.isLearner)
                        //	$rootScope.$broadcast("refreshToken");
                    }, function (error) {
                        vm.error = error.data.exceptionMessage ? error.data.exceptionMessage : error.data.message;
                        vm.busy = false;
                    });
                }
            };
            vm.onChange = function () {
                vm.success = false;
                vm.error = "";
            };
        }
    });
}());
